import React, { Component, useEffect, useRef, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';

import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';
import useSortData from "../Pagination/SortData";

// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const DeptListLeaves = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	const emptyUser={
		url_name: "",
		url_link: "",
		parent: ""
	}

	const [user, setUser] = useState({
		url_name: "",
		url_link: "",
		parent: ""
	})

	const handelInput = (event) => {
		event.preventDefault();
		const { name, value } = event.target;
		console.log(name, value)
		setUser({ ...user, [name]: value });
	}



	const [url_name, setUrlname] = useState('');
	const [url_id, setUrlid] = useState('');
	const [url_link, setUrllink] = useState('');
	const [parent, setParent] = useState('');
	const history = useHistory();
	const [data, setData] = useState([]);
	const [datacount, setDataCount] = useState([]);
	const [dataval, setdataval] = useState([]);
	const [currentPageId, setCurrentPageId] = useState(1);
	const [checkedItems, setCheckedItems] = useState({});
	const [cnt, setCnt] = useState(null);
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(true);
	const [isApproving, setIsApproving] = useState(false);
	const approvingRef = useRef(false);

	const { sortConfig, sortData, handleSort } = useSortData();


	// const [anand, setAnand]= useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [entriesPerPage,setEntriesPerPage]=useState(10);
	let filteredItems = data.filter((item) =>



		`${item.employee_id.toLowerCase()}${item.employee_name.toLowerCase()}${item.department_name.toLowerCase()}${item.type_name.toLowerCase()}${item.duration.toLowerCase()}${item.applied_on.toLowerCase()}${item.reason.toLowerCase()}`.includes(searchTerm.toLowerCase())

	);
	const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
	const indexOfLast = currentPage * entriesPerPage;
	const indexOfFirst = indexOfLast - entriesPerPage;
	// const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

	const sortedItems = sortData(filteredItems, checkedItems);
	const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);

	useEffect(() => {
		setCurrentPage(1);
	}, [searchTerm]);

	

	const handleSearch = (event) => {
		setSearchTerm(event.target.value);
	};


	const clearInput = () => {
		setSearchTerm("");
	  };


	



	useEffect(() => {
		axios.get(API_BASE_URL + '/dept_leave_list', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})


			.then((res) =>{
				setData(res.data);
				const defaultChecked = {};
  res.data.forEach(item => {
	  if (item.dpt_status == 1) {
    defaultChecked[item.leave_id] = true;
	  }
  });
  setCheckedItems(defaultChecked);
  }) 
			// .then(res => console.log(res.data))
			.catch(err => console.log(err));
	}, [])




	useEffect(() => {
		handleUpdate();
	}, []);

	var elements = [];
	for (var i = 1; i <= datacount.total_page; i++) {
		elements.push(i);
	}

	//   for(var i=1;i<=datacount.total_page;i++){
	// 	elements.push(<li className="page-item"><a className="page-link" href="" onClick={() => handlePagination(i)}>
	// 	  {i}
	//   </a></li>);
	// }

	//console.log(elements)

	//   const [currentPage,setCurrentPage]= useState(1);
	const recordsPerPage = 10;

	const lastIndex = currentPage * recordsPerPage;
	const firstIndex = lastIndex - recordsPerPage;
	const records = data.slice(firstIndex, lastIndex);
	const npage = Math.ceil(data.length / recordsPerPage);
	const numbers = [...Array(npage + 1).keys()].slice(1);




	// const paginate= (page) => setCurrentPage(page);

	const handleUpdate = async (id) => {

		axios.get(API_BASE_URL + '/showurl/' + id, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
			.then(res1 => setUser(res1.data))
			.catch(err => console.log(err))
	};


	const handlePagination = async (numpage) => {
		// alert('hi');
		// alert(numpage);
		axios.get(API_BASE_URL + '/fetchurl?per_page=10&page_num=' + numpage, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
			.then(res1 => setData(res1.data))
			.catch(err => console.log(err))
	};

	const handleApproveSelected = async () => {
  // guard against double / rapid clicks while a request is already in flight
  if (approvingRef.current) return;

  const selectedIds = Object.keys(checkedItems).filter(id => checkedItems[id]);

  if (selectedIds.length === 0) {
    // toast.warn("No leaves selected for approval");
	toast.error("No leaves selected for approval", {
						toastId: "no-leaves-selected", // prevents the same toast stacking on repeat clicks
						position: "bottom-right",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "colored",

					});
    return;
  }

//   alert(JSON.stringify(selectedIds, null, 2));

  approvingRef.current = true;
  setIsApproving(true);

  try {
    const token = localStorage.getItem("authToken");
    const response = await axios.post(
      `${API_BASE_URL}/dept_approve_leaves`,
      { leave_id: selectedIds },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    if (response.status == 200) {
					toast.success(response.data.message, {
						position: "bottom-right",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "colored",
	
					});

					const timeout = setTimeout(() => {
				window.location.href = "Dept-leaves";
				// window.location.reload(); // Reload the current page
			}, 3000); // Refresh after 5 seconds
	
					// setTimeout(() => {
					// 	history.push("Dept-leaves");
					// }, 1000);

				} else {
					// unexpected status - allow the user to retry
					approvingRef.current = false;
					setIsApproving(false);
				}

  } catch (err) {
    console.error(err);
    toast.error("Failed to approve selected leaves");
    approvingRef.current = false;
    setIsApproving(false);
  }
};



useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await axios.get(API_BASE_URL + "/getdeptLeaveListcnt", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        },
      });
      // console.log(response.data);
      
      setCnt(response.data);
      // console.log("Exit Procedures Count:", cnt.exitProceduresCount);
    } catch (err) {
      console.error("Error fetching data:", err);
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, []);


// Compensate leave: 1 => Sick Leave, 2 => Casual Leave
const getCompensateLeave = (id) => {
  if (String(id) === "1") return "Sick Leave";
  if (String(id) === "2") return "Casual Leave";
  return "";
};

const columns = [
  { label: "Action", key: "action_sort", sortable: true },
  { label: "Employee Id", key: "employee_id", sortable: true },
  { label: "Employee", key: "employee_name", sortable: true },
  { label: "Department", key: "department_name", sortable: true },
  { label: "Leave Type", key: "type_name", sortable: true },
  { label: "Compensate Leave", key: "componsate_leave_id", sortable: true },
  { label: "Request Duration", key: "duration", sortable: true },
  { label: "Applied On", key: "applied_on", sortable: true },
  { label: "Reason", key: "reason", sortable: true },
  { label: "Hod", key: "hod_status", sortable: true },
  { label: "HR", key: "hr_status", sortable: true },
];



	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />

							{/* <div className="d-flex justify-content-between align-items-center mb-3">
								<div className="header-action">
									<div id="button">
										<button style={{ float: 'center' }}
											type="button"
											className="btn btn-primary"
											data-toggle="modal"
											data-target="#exampleModal"
											onClick={()=>{setUser(emptyUser)}}
										>
											<i className="fe fe-plus mr-2" />
											Add
										</button>
									</div>
								</div>
							</div> */}

						</div>
					</div>


					<div className="section-body">
						<div className="container-fluid">
							<div className="tab-content">
								<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
									<div className="card">
										<div className="card-header d-flex justify-content-between align-items-center">
											<h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
											  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
											    <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"/>
											  </svg>
											  Manage Leaves
											</h3>
											<div
  className="card-options"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
  }}
>
  <EntriesSelector
    entriesPerPage={entriesPerPage}
    setEntriesPerPage={setEntriesPerPage}
    setCurrentPage={setCurrentPage}
  />

  {/* 🔽 SEARCH BOX WRAPPER */}
  <div style={{ position: "relative", width: "200px" }}>
    <input
      type="text"
      className="form-control form-control-sm"
      placeholder="Search"
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
      }}
      style={{
        width: "100%",
        height: "30px",
        fontSize: "13px",
        borderRadius: "4px",
        paddingRight: "28px", // ✅ space for X
      }}
    />

    {searchTerm.length > 0 && (
      <span
        onClick={clearInput}
        style={{
          position: "absolute",
          right: "8px",        // ✅ INSIDE input
          top: "50%",          // ✅ vertically centered
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#aaa",
          fontSize: "16px",
          userSelect: "none",
        }}
      >
        ✖
      </span>
    )}
  </div>
</div>
										</div>












										<div className="card-body">
											<div className="table-responsive sticky-table-wrap">
												<table className="table table-hover table-striped table-vcenter text-nowrap mb-0 sticky-table">
													<thead>
														<tr>
														<th
  onClick={() => handleSort("checkbox")}
  style={{
    cursor: "pointer",
    userSelect: "none",
    whiteSpace: "nowrap"
  }}
>
  {cnt?.listcount > 0 && (
    <input
      type="checkbox"
      checked={
        Object.values(checkedItems).length > 0 &&
        Object.values(checkedItems).every(Boolean)
      }
      onClick={(e) => e.stopPropagation()} // ⛔ prevent sort on click
      onChange={(e) => {
        const newChecked = {};
        data.forEach(item => {
          newChecked[item.leave_id] = e.target.checked;
        });
        setCheckedItems(newChecked);
      }}
    />
  )}

  {/* SORT ICON */}
  <span style={{ marginLeft: "6px", fontSize: "12px" }}>
    {sortConfig.key === "checkbox"
      ? sortConfig.direction === "asc"
        ? "▲"
        : "▼"
      : "⇅"}
  </span>
</th>
															{/* <th>Action</th> */}
															 {columns.map((col) => (
																<th
																	key={col.key}
																	onClick={col.sortable ? () => handleSort(col.key) : null}
																	style={{ cursor: col.sortable ? "pointer" : "default" }}
																>
																	{col.label}
																	{col.sortable && (
																sortConfig.key === col.key
																	? (sortConfig.direction === "asc" ? " ▲" : " ▼")
																	: " ⇅"   // <-- DEFAULT SORT ICON
																)}
																	</th>
																))}
														</tr>
													</thead>
													<tbody>



														{
															filteredData.map((deptlve, index) => {

																return <tr key={index}>
																<td>
{deptlve.dpt_status === 1 && (
  <input
    type="checkbox"
    checked={checkedItems[deptlve.leave_id] || false}
    onChange={(e) =>
      setCheckedItems({
        ...checkedItems,
        [deptlve.leave_id]: e.target.checked,
      })
    }
  />
   )}
</td>


																	<td className="d-flex">
  {deptlve.dpt_status === 1 && (
    <Link to={`/dept-leave-details?id=${deptlve.leave_id}`}>
      <i className="fe fe-maximize" />
    </Link>
  )}
</td>

																	<td>
																		<span>{deptlve.employee_id}</span>
																	</td>
																	<td>
																		<span>{deptlve.employee_name}</span>
																	</td>
																	<td>
																		<span>{deptlve.department_name}</span>
																	</td>


																	<td>
																		<span>{deptlve.type_name}</span>
																	</td>

																	<td>
																		<span>{getCompensateLeave(deptlve.componsate_leave_id)}</span>
																	</td>

																	<td>
																		<span>{deptlve.duration}</span>
																	</td>

																	<td>
																		<span>{deptlve.applied_on}</span>
																	</td>

																	<td>
																		<span>{deptlve.reason}</span>
																	</td>

																

																	<td>
																		<span>{ReactHtmlParser(deptlve.hod_status)}</span>
																	</td>

																	<td>
																		<span>{ReactHtmlParser(deptlve.hr_status)}</span>
																	</td>

																	
																</tr>


															})
														}

													</tbody>
												</table>
											</div>



											<Pagination
												currentPage={currentPage}
												totalPages={totalPages}
												onPageChange={setCurrentPage}
												/>



<div className="mt-3 text-end">
  <button
    className="btn btn-primary"
     onClick={handleApproveSelected}
     disabled={isApproving}
  >
    {isApproving ? "Approving..." : "Approve Leave"}
  </button>
</div>





										</div>
									</div>
								</div>


							</div>
						</div>
					</div>

				</div>
			</div>





			




			




		</>
	);

}



const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(DeptListLeaves);